<template>
  <div class="bg-ontick-graphite-500 relative z-40 h-full max-h-screen">
    <!-- <sidebar-mobile /> -->
    <div class="hidden h-full overflow-y-auto overflow-x-hidden lg:flex">
      <div
        :class="compress_sidebar ? 'w-16' : 'w-64'"
        class="bg-ontick-graphite-500 border-ontick-carbon-500 z-50 flex flex-col border-r shadow transition-all duration-500 ease-in-out"
      >
        <div class="flex flex-1 flex-col pb-24">
          <div class="bg-ontick-graphite-500 sticky top-0 flex items-center justify-center py-4">
            <router-link to="/" active-class="not-active">
              <div
                :class="compress_sidebar ? 'flex-col items-center space-x-0 space-y-2 ' : 'items-end space-x-1'"
                class="flex justify-center"
                is="transition-group"
                name="company"
              >
                <span
                  :class="compress_sidebar ? 'h-10 w-10' : 'w-full'"
                  :key="compress_sidebar ? $icons.small_logo : $icons.logo"
                  v-html="compress_sidebar ? $icons.small_logo : $icons.logo"
                />
                <ontick-plan-logo-component
                  :plan="getSelectedAccount.account_plan_name"
                  :daysLeft="getLicenseData ? getLicenseData.days_left : null"
                  :compressed="compress_sidebar"
                  darkBg
                  key="1"
                />
                <!-- <div
                  key="2"
                  v-show="accountTypes.selectedAccount.account_type == 'DEMO'"
                  :class="compress_sidebar ? 'mt-1 text-center' : '-mb-0.5'"
                  class="transform-gpu text-xs font-semibold text-gray-300 transition-all duration-300"
                >
                  DEMO
                </div> -->
              </div>
            </router-link>
          </div>
          <div class="flex-1">
            <nav class="space-y-2" v-if="compress_sidebar">
              <template v-for="(item, index) in nav">
                <router-link
                  v-tippy="{
                    arrow: true,
                    theme: 'green',
                    boundary: 'viewport',
                  }"
                  :exact="['/', '/marketplace'].includes(item.url)"
                  :content="item.title"
                  v-if="item.visible"
                  :key="index"
                  :to="item.url"
                  :class="[
                    $route.path == item.url ? activeClass : inactiveClass,
                    'group text-made flex items-center px-2 py-2 font-normal leading-6 transition duration-150 ease-in-out',
                  ]"
                >
                  <i
                    class="text-ontick-blue-500 demo:text-gray-500 camp:text-ontick-yellow-600"
                    :class="
                      item.title === 'Ranking' ? 'ml-[11px] mr-4 w-[20px] min-w-[20px] max-w-[20px]' : 'ml-3 mr-4'
                    "
                    v-html="item.icon"
                  ></i>
                  <p v-show="!compress_sidebar">{{ item.title }}</p>
                </router-link>
              </template>
              <button
                v-tippy="{
                  arrow: true,
                  theme: 'green',
                  boundary: 'viewport',
                }"
                @click="partnerTabIsActive = !partnerTabIsActive"
                content="Exibir parceiros contratados"
                v-if="getExtensions"
                :class="[
                  inactiveClass,
                  'group text-made flex items-center px-2 py-2 font-normal leading-6 transition duration-150 ease-in-out',
                ]"
              >
                <i
                  class="text-ontick-blue-500 demo:text-gray-500 camp:text-ontick-yellow-600 ml-3 mr-4 w-[24px]"
                  v-html="$icons.person_check"
                ></i>
                <p v-show="!compress_sidebar">Parceiros ativados</p>
              </button>
            </nav>
            <nav class="space-y-2" v-else>
              <template v-for="(item, index) in nav">
                <router-link
                  v-if="item.visible"
                  :exact="['/', '/marketplace'].includes(item.url)"
                  :key="index"
                  :to="item.url"
                  :class="[
                    $route.path == item.url ? activeClass : inactiveClass,
                    'group text-made flex items-center px-2 py-2 font-normal leading-6 transition duration-150 ease-in-out',
                  ]"
                >
                  <i
                    class="text-ontick-blue-500 demo:text-gray-500 camp:text-ontick-yellow-600"
                    :class="
                      item.title === 'Ranking'
                        ? 'ml-[11px] mr-4 h-[20px] w-[20px] min-w-[20px] max-w-[20px]'
                        : 'ml-3 mr-4'
                    "
                    v-html="item.icon"
                  ></i>
                  <p v-show="!compress_sidebar" class="whitespace-nowrap">
                    {{ item.title }}
                  </p>
                </router-link>
              </template>
              <button
                v-if="getExtensions"
                @click="partnerTabIsActive = !partnerTabIsActive"
                :class="[
                  inactiveClass,
                  'group text-made flex w-full items-center px-2 py-2 font-normal leading-6 transition duration-150 ease-in-out',
                ]"
              >
                <i
                  class="text-ontick-blue-500 demo:text-gray-500 camp:text-ontick-yellow-600 ml-3 mr-4 w-full min-w-[22px] max-w-[22px]"
                  v-html="$icons.person_check"
                ></i>
                <div v-show="!compress_sidebar" class="flex h-full w-full items-center justify-between">
                  <span class="whitespace-nowrap"> Parceiros ativados </span>
                </div>
              </button>
            </nav>

            <!-- <span
              class="bg-ontick-steel-500 mx-6 my-2 flex h-[2px]"
              v-if="getExtensions && getExtensions.length"
            ></span> -->
            <!-- <nav
              class="space-y-2"
              v-if="
                getExtensions &&
                getExtensions.length &&
                getSelectedAccount.account_type !== 'CONTEST'
              "
            >
              <sidebar-item-component
                v-for="(item, index) in getExtensions"
                :key="index"
                :data="item"
                :compress_sidebar="compress_sidebar"
                @expand="compress_sidebar = false"
                @compress="compress_sidebar = true"
              />
            </nav> -->
          </div>
          <!-- <div
            class="flex w-full justify-center px-6 pt-6"
            v-if="['TRIAL', 'BASIC'].includes(getUserPlan.plan_name)"
            :class="compress_sidebar ? 'pb-[274px]' : 'pb-[122px]'"
          >
            <ontick-button
              v-if="compress_sidebar"
              v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
              content="Faça o upgrade"
              class="w-full self-center"
              color="secondary"
              @click.native="goToPlans"
            >
              <i v-html="$icons.upgrade" class="text-white"></i>
            </ontick-button>
            <ontick-button v-else class="w-full self-center" color="secondary" @click.native="goToPlans">
              <span>Faça o upgrade</span>
            </ontick-button>
          </div> -->
          <div
            class="fixed bottom-0 z-20 transition-all duration-500 ease-in-out"
            :class="compress_sidebar ? 'w-16' : 'w-64'"
          >
            <account-select
              v-if="compress_sidebar"
              v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
              content="Selecionar conta"
              :minimize="false"
              class="hidden w-full md:block"
            />
            <account-select v-else :minimize="true" class="hidden w-full md:block" />

            <div
              :class="!compress_sidebar ? 'flex w-64 ' : 'w-16 flex-none'"
              class="relative rounded-md shadow-sm transition-all duration-500 ease-in-out"
            >
              <button
                v-if="compress_sidebar"
                v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
                content="Menu do usuário"
                @click="active_user = !active_user"
                v-click-outside="activeUser"
                :class="
                  active_user
                    ? 'text-ontick-blue-600'
                    : 'text-ontick-blue-600 demo:text-gray-300 camp:text-ontick-yellow-600'
                "
                class="btn_nav_sidebar relative z-10"
              >
                <span v-html="$icons.profile"></span>
                <ontick-alert-badge v-if="hasUnreadMessages" position="tr" :distance="2" />
              </button>
              <button
                v-else
                @click="active_user = !active_user"
                v-click-outside="activeUser"
                :class="
                  active_user
                    ? 'text-ontick-blue-600'
                    : 'text-ontick-blue-600 demo:text-gray-300 camp:text-ontick-yellow-600'
                "
                class="btn_nav_sidebar relative z-10"
              >
                <span v-html="$icons.profile"></span>
                <ontick-alert-badge v-if="hasUnreadMessages" position="tr" :distance="2" />
              </button>

              <button
                v-if="compress_sidebar"
                v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
                content="Notificações"
                @click="active_notification = !active_notification"
                v-click-outside="activeNotification"
                type="button"
                :class="
                  active_notification
                    ? 'text-ontick-blue-600'
                    : 'text-ontick-blue-600 demo:text-gray-300 camp:text-ontick-yellow-600'
                "
                class="btn_nav_sidebar"
              >
                <span v-html="$icons.bell"></span>

                <span
                  v-show="notification_stream.length > 0"
                  class="bg-ontick-green-500 text-ontick-graphite-500 ring-ontick-green-500 absolute top-1 right-4 block h-4 w-4 rounded-full text-xs font-semibold ring-2"
                  >{{ notification_stream.length }}</span
                >
              </button>
              <button
                v-else
                @click="active_notification = !active_notification"
                v-click-outside="activeNotification"
                type="button"
                :class="
                  active_notification
                    ? 'text-ontick-blue-600'
                    : 'text-ontick-blue-600 demo:text-gray-300 camp:text-ontick-yellow-600'
                "
                class="btn_nav_sidebar"
              >
                <span v-html="$icons.bell"></span>

                <span
                  v-show="notification_stream.length > 0"
                  class="bg-ontick-green-500 text-ontick-graphite-500 ring-ontick-green-500 absolute top-1 right-4 block h-4 w-4 rounded-full text-xs font-semibold ring-2"
                  >{{ notification_stream.length }}</span
                >
              </button>
              <button
                v-if="compress_sidebar"
                v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
                content="Streamer"
                @click="$emit('active_stream')"
                :class="
                  active_stream
                    ? 'text-gray-300'
                    : 'text-ontick-blue-500 demo:text-gray-300 camp:text-ontick-yellow-600'
                "
                class="btn_nav_sidebar"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  style="transform:; -ms-filter:"
                >
                  <path
                    d="M20,3H4C2.897,3,2,3.897,2,5v14c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V5C22,3.897,21.103,3,20,3z M20,5l0.001,4H4V5 H20z M4,19v-8h16.001l0.001,8H4z"
                  ></path>
                  <path d="M14 6H16V8H14zM17 6H19V8H17z"></path>
                </svg>
                <span
                  v-show="qtd_position > 0"
                  class="bg-ontick-blue-700 ring-ontick-blue-700 absolute top-2 right-2 inline-flex h-4 w-4 justify-center rounded-full text-xs font-semibold text-gray-300 ring-2"
                  >{{ qtd_position }}</span
                >
              </button>
              <button
                v-else
                @click="$emit('active_stream')"
                :class="
                  active_stream
                    ? 'text-gray-300'
                    : 'text-ontick-blue-500 demo:text-gray-300 camp:text-ontick-yellow-600'
                "
                class="btn_nav_sidebar"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  style="transform:; -ms-filter:"
                >
                  <path
                    d="M20,3H4C2.897,3,2,3.897,2,5v14c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V5C22,3.897,21.103,3,20,3z M20,5l0.001,4H4V5 H20z M4,19v-8h16.001l0.001,8H4z"
                  ></path>
                  <path d="M14 6H16V8H14zM17 6H19V8H17z"></path>
                </svg>
                <span
                  v-show="qtd_position > 0"
                  class="bg-ontick-blue-700 ring-ontick-blue-700 absolute top-2 right-2 inline-flex h-4 w-4 justify-center rounded-full text-xs font-semibold text-gray-300 ring-2"
                  >{{ qtd_position }}</span
                >
              </button>
              <button
                v-if="compress_sidebar"
                v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
                content="Expandir"
                @click="compress_sidebar = !compress_sidebar"
                class="focus:shadow-outline bg-ontick-steel-500 text-ontick-blue-500 demo:text-gray-300 camp:text-ontick-yellow-600 inline-flex w-full items-center justify-center px-4 py-4 hover:text-white focus:outline-none"
              >
                <dl
                  class="transform-gpu transition-all duration-200"
                  :class="compress_sidebar ? 'rotate-180' : ' rotate-0'"
                  v-html="$icons.chevron_left"
                ></dl>
              </button>
              <button
                v-else
                @click="compress_sidebar = !compress_sidebar"
                class="focus:shadow-outline bg-ontick-steel-500 text-ontick-blue-500 demo:text-gray-300 camp:text-ontick-yellow-600 inline-flex w-full items-center justify-center px-4 py-4 hover:text-white focus:outline-none"
              >
                <dl
                  class="transform-gpu transition-all duration-200"
                  :class="compress_sidebar ? 'rotate-180' : ' rotate-0'"
                  v-html="$icons.chevron_left"
                ></dl>
              </button>
              <menu-user
                :user="user_name"
                :user_picture="user_picture"
                :user_code="user_code"
                :openMenuNavbar="active_user"
                :minimize="!compress_sidebar"
              />
              <notification-component :openMenuNotification="active_notification" />
            </div>
          </div>
        </div>
      </div>

      <!-- PARTNER TAB -->
      <partners-tab-component
        :active="partnerTabIsActive"
        :extensions="extensions"
        :collapsed="compress_sidebar"
        @close="partnerTabIsActive = false"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import ApplicationStatus from "../application-status/application-status.component";
import ClickOutside from "vue-click-outside";
import SidebarItemComponent from "./sidebar-item.component.vue";
import PartnersTabComponent from "./partners-tab.component.vue";

export default {
  name: "sidebar",

  components: {
    ApplicationStatus,
    MenuUser: () => import("../sidebar/sidebar-menu-user.component.vue"),
    NotificationComponent: () => import("@/app/modules/notification/components/notification-navbar.component"),

    AccountSelect: () => import("../account/account-select.component.vue"),
    OntickPlanLogoComponent: () => import("../basic/ontick-plan-logo.component.vue"),
    SidebarItemComponent,
    PartnersTabComponent,
  },

  props: {
    nav: Array,
    active_stream: Boolean,
  },

  directives: {
    ClickOutside,
  },

  data() {
    return {
      openSidebarMobile: false,
      // compress_sidebar: window.location.hostname == "localhost" ? true : false,
      compress_sidebar: false, // FIXME: (trade_ideas) TEMPORÁRIO
      active_user: false,
      active_notification: false,
      activeRoute: "/",
      activeClass:
        "bg-ontick-carbon-500 border-l-4 demo:border-gray-400 camp:text-ontick-yellow-600 camp:border-ontick-yellow-600 border-ontick-blue-800 dark:text-gray-100",
      inactiveClass: "text-gray-100 hover:text-white ml-1",

      notification: [],
      partnerTabIsActive: false,
    };
  },

  computed: {
    ...mapState({
      config: (state) => state.config,
      accountTypes: (state) => state.accountTypes,
      qtd_position: (state) => state.stream.qtd_position,
      user_name: (state) => state.config.user_name,
      user_picture: (state) => state.config.user_picture,
      user_code: (state) => state.config.user_code,
      notification_stream: (state) => state.notification.notification_stream,
    }),
    ...mapGetters({
      getExtensions: "config/getExtensions",
      getUserPlan: "config/getUserPlan",
      getLicenseData: "config/getLicenseData",
      hasUnreadMessages: "config/hasUnreadMessages",
      getSelectedAccount: "accountTypes/getSelectedAccount",
    }),
    extensions() {
      let arr = [];
      if (this.getExtensions) {
        this.getExtensions.forEach((item) => {
          item.extensions.forEach((extension) => {
            arr.push({
              extension_name: item.extensions.length === 1 ? item.extension_owner : extension.extension_name,
              extension_id: extension.extension_id,
              extension_path: item.extension_path,
              extension_logo: extension.extension_logo,
            });
          });
        });
      }
      return arr;
    },
  },

  methods: {
    log(val) {
      // console.log(val);
    },
    // goToPlans() {
    //   this.$router.push("/account?tag=plans");
    // },
    activeUser() {
      this.active_user = false;
    },

    activeNotification() {
      this.active_notification = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.rtl {
  direction: rtl;
  & > * {
    direction: ltr;
  }
}
.company {
  &-move {
    transition: all 300ms ease-in-out 50ms;
  }
  &-enter-active {
    transition: all 200ms ease-out;
  }

  &-leave-active {
    transition: all 200ms ease-in-out;
    position: absolute;
    z-index: 50;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
  &-enter {
    transform: scale(0.9);
  }
}
.btn_nav_sidebar {
  @apply bg-ontick-steel-500 hover:bg-ontick-steel-600 demo:hover:text-gray-100 relative inline-flex w-full items-center justify-center px-4 py-4 text-sm  font-medium focus:outline-none;
}
.active {
  @apply bg-ontick-carbon-500 border-l-4 demo:border-gray-400 camp:text-ontick-yellow-600 camp:border-ontick-yellow-600 border-ontick-blue-800 dark:text-gray-50 #{!important};
}
// .router-link-exact-active.active {
//   @apply bg-ontick-carbon-500 border-l-4 demo:border-gray-400 camp:text-ontick-yellow-600 camp:border-ontick-yellow-600 border-ontick-blue-800 dark:text-gray-50 #{!important};
// }
</style>
